"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CookieConsent_module_1 = require("./modules/CookieConsent.module");
const loadCookieMessageModule = (initialData) => ({
    hasRouter: false,
    modules: [(0, CookieConsent_module_1.default)(initialData)],
});
exports.default = loadCookieMessageModule;
